// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1MOL-","logo":"Header_logo__3EvUy","navigation":"Header_navigation__1m80W","sidebarButton":"Header_sidebarButton__3o0hZ","overlay":"Header_overlay__28knl"};